/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsSbomComponentProperty {
    getFixupPrototypeFunction() { return AppSecopsSbomComponentProperty.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsSbomComponentProperty>): AppSecopsSbomComponentProperty {
        let obj = Object.assign(new AppSecopsSbomComponentProperty(), model);
        AppSecopsSbomComponentProperty.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsSbomComponentProperty>): AppSecopsSbomComponentProperty {
        if (!model) return null;
        return AppSecopsSbomComponentProperty.newInstance(<AppSecopsSbomComponentProperty> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsSbomComponentProperty) {
        if (!obj) return;

        models.AppSecopsSbomComponentProperty.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsSbomComponentProperty): boolean {
        Object.setPrototypeOf(obj, AppSecopsSbomComponentProperty.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Name of the SBOM component property
     */
    name: string;

    /**
     * value of the SBOM component
     */
    value: string;

}
